import { render, staticRenderFns } from "./SelectSeatPrice.vue?vue&type=template&id=27a339c1&scoped=true&"
import script from "./SelectSeatPrice.vue?vue&type=script&lang=ts&"
export * from "./SelectSeatPrice.vue?vue&type=script&lang=ts&"
import style0 from "./SelectSeatPrice.vue?vue&type=style&index=0&id=27a339c1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a339c1",
  null
  
)

export default component.exports